import { 
    IonRouterLink,
    IonAvatar,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardContent,
    IonCardTitle,
    IonButtons,
    IonBackButton,
    IonContent, 
    IonInput, 
    IonButton, 
    IonItem, 
    IonHeader,   
    IonPage, 
    IonTitle, 
    IonToolbar,
    IonGrid,
    IonRow,
    IonCol,
    IonLabel,
    IonIcon,
    NavContext,
    useIonViewWillEnter,
    IonText,
    IonRefresher,
    IonRefresherContent,
    IonAlert,
    IonList,
    useIonRouter
} from '@ionic/react';
import { chevronForwardOutline, trashOutline, createOutline, imageOutline } from "ionicons/icons";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";

import { LANGUAGE, GetStr } from "../language/Language";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import NServer, { UIElement } from "../components/NServer";
import { showTab, updateTab } from "../components/Tabs";

import './Main.css';  

interface ChannelProp extends RouteComponentProps<{
    id : any
    }> 
{}

const ChannelDetail : React.FC<ChannelProp> = ({match}) => {

    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [avatar, setAvatar] = useState("https://nwallet.site/img/channel.png");
    const [category, setCategory] = useState("");
    const [askDelete, setAskDelete] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });
    
    // retrieve the user info
    const getData = async () => {
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            channel: match.params.id
        };

        var server = new NServer();
        await server.getList("nc_channel_info", state);

        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            return;
        }

        setTitle(server.data.title);
        setDesc(server.data.desc);
        setCategory(server.data.category);
        setAvatar(server.data.avatar);
    }

    // delete the channel
    const deleteChannel = async () => {

    }

    return (
            <IonPage>
                <IonHeader>
                </IonHeader>
                <IonContent fullscreen>
                    <IonAlert
                        isOpen={askDelete}
                        onDidDismiss={() => setAskDelete(false)}
                        message={ GetStr(LANGUAGE.TXT_CH_DELETE_ASK) }
                        buttons={[
                            {
                                text: GetStr(LANGUAGE.TXT_CANCEL),
                                role: 'cancel',
                                cssClass: 'secondary',
                                id: 'cancel-button'
                            },
                            {
                                text: GetStr(LANGUAGE.TXT_OK),
                                id: 'confirm-button',
                                handler: ()=> { deleteChannel(); }
                            }
                        ]}
                    />

                    <div id="main-bk" />
                    <IonToolbar color="none">
                        <IonButtons slot="end">
                        </IonButtons>
                    </IonToolbar>
                    <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonRouterLink routerLink={"/imgcrop/chavt/" + match.params.id + "/studio/1/1"} routerDirection="forward">
                                <IonAvatar className="main-avatar">
                                    <img src={avatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/channel.png' } } />
                                </IonAvatar>
                            </IonRouterLink>
                            <IonCard className="ion-text-center margin-n25">
                                <IonCardHeader className="margin-25">
                                    <IonCardTitle><h1><b>{ title }</b></h1></IonCardTitle>
                                    <IonCardSubtitle>
                                        <div className="ion-padding-bottom"><b>[ { category } ]</b></div>
                                        <div className="ion-padding-bottom"><i>{ GetStr(LANGUAGE.TXT_CH_DESCRIP) }</i></div>
                                        <div className="ion-text-left">{ desc }</div>
                                    </IonCardSubtitle>
                                </IonCardHeader>
                            </IonCard>
                            <IonCard>
                                <IonList>
                                    <IonItem routerLink={"/new_channel/"+match.params.id} lines="none">
                                        <IonIcon icon={createOutline} slot="start" />
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_CH_EDIT) }</IonLabel>
                                        <IonIcon icon={chevronForwardOutline} slot="end" />
                                    </IonItem>
                                    <IonItem routerLink={"/imgcrop/chavt/" + match.params.id + "/studio/1/1"} lines="none">
                                        <IonIcon icon={imageOutline} slot="start" />
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_CH_UPLOAD_AVATAR) }</IonLabel>
                                        <IonIcon icon={chevronForwardOutline} slot="end" />
                                    </IonItem>
                                    <IonItem onClick={(e) => { setAskDelete(true); } } lines="none">
                                        <IonIcon icon={trashOutline} color="danger" slot="start" />
                                        <IonLabel color="danger">{ GetStr(LANGUAGE.TXT_CH_DELETE) }</IonLabel>
                                        <IonIcon icon={chevronForwardOutline} color="danger" slot="end" />
                                    </IonItem>
                                </IonList>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                </IonContent>
            </IonPage>
    );
}

export default ChannelDetail;